import { render } from "./Home.vue?vue&type=template&id=2471da18&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=2471da18&scoped=true&lang=scss"

import exportComponent from "/home/m/neurometronomy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2471da18"]])

export default __exports__